__turbopack_context__.v({
  "backgroundEggshell": "sectionGroup-module-scss-module__OJRDKW__backgroundEggshell",
  "backgroundGradient": "sectionGroup-module-scss-module__OJRDKW__backgroundGradient",
  "noPaddingBottom": "sectionGroup-module-scss-module__OJRDKW__noPaddingBottom",
  "noPaddingTop": "sectionGroup-module-scss-module__OJRDKW__noPaddingTop",
  "sectionGroup": "sectionGroup-module-scss-module__OJRDKW__sectionGroup",
});
